import jQuery from 'jquery';

export default {
  init() {
    // On "Register Now" click, scroll down to form
    jQuery("a[href='#register']").on('click', function (event) {
      event.preventDefault();
      var w = jQuery('body').width();
      jQuery([document.documentElement, document.body]).animate({
        scrollTop: jQuery("a[name='register']").offset().top - (w > 575 ? 0 : 64)
      }, 1000);
    });
  },
  finalize() {
    
  },
};
  